import { ComponentTabs } from "@picovico/ui";
import React from "react";
import { ChangePasswordFormCard, UserProfileFormCard } from "../Cards";
import { TabProps } from "@chakra-ui/react";

function ProfileEdit({
  headProps = {},
  formProps,
  ...props
}: {
  headProps?: TabProps;
  formProps?: {
    [key: string]: unknown;
  };
  [key: string]: unknown;
}) {
  const tabsList = [
    {
      title: "Profile",
      component: (
        <UserProfileFormCard
          formWrapperBoxProps={{
            maxW: "full",
            boxShadow: "none",
          }}
          {...formProps}
        />
      ),
      headProps,
    },
    {
      title: "Change Password",
      component: (
        <ChangePasswordFormCard
          formWrapperBoxProps={{
            maxW: "full",
            boxShadow: "none",
          }}
          formTitle="Change Password"
          {...formProps}
        />
      ),
      headProps,
    },
  ];

  return (
    <ComponentTabs
      variant="enclosed"
      tabPanelProps={{
        padding: 0,
      }}
      tabList={tabsList}
      {...props}
    />
  );
}

export default ProfileEdit;
